import { Tooltip } from '@shape-ds/components';
import React from 'react';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import { findByAssetNameRecursive, findByIdRecursive } from 'utils/Trail';
import { useAssetsByWorkspaceQuery } from 'queries/assets/queries';
import './style.scss';
import { getTooltipText } from 'utils/EventUtil';

type AssetBreadCrumbTooltipProps = {
  assetId?: string;
  assetName?: string;
};

const AssetBreadCrumbTooltip: React.FC<AssetBreadCrumbTooltipProps> = ({ assetName, assetId }) => {
  const { data } = useAssetsByWorkspaceQuery();

  const tree = data?.items ?? [];
  const trail = assetId
    ? findByIdRecursive(tree, assetId)
    : findByAssetNameRecursive(tree, assetName);
  const trailWithoutThisAsset = trail?.breadcrumbPath?.filter(
    (i) => (assetName && i.name !== assetName) || (assetId && i.id !== assetId),
  );
  trailWithoutThisAsset?.pop();

  const assets = trailWithoutThisAsset
    ? trailWithoutThisAsset.reverse()
    : [{ name: '', id: '', has_subitems: false, external_id: '' }];

  const tooltipText = getTooltipText(assets, trail?.item?.name ?? assetName);

  return (
    <Tooltip
      followCursor={false}
      placement="top"
      title={<span>{tooltipText}</span>}
      className="asset-breadcrumb-tooltip"
    >
      <span className="asset-breadcrumb">
        {tooltipText && (
          <>
            <MoreHorizOutlinedIcon /> {' / '}
          </>
        )}
        <span className="asset-overflow-text">{trail?.item?.name ?? assetName}</span>
      </span>
    </Tooltip>
  );
};

export default AssetBreadCrumbTooltip;
